module.exports = __webpack_public_path__ + "img/stand_height.14560a46.png";